import { render, staticRenderFns } from "./wagesSettings.vue?vue&type=template&id=3917ca9b&scoped=true&"
import script from "./wagesSettings.vue?vue&type=script&lang=js&"
export * from "./wagesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3917ca9b",
  null
  
)

export default component.exports